import './SearchResults.scss'

import { loadingSpinnerSvg } from '@components/loading-spinner/loading-spinner'
import { useSearchResults } from '@react/SearchResults/hooks/useSearchResults'
import { TabType } from '@react/SearchResults/SearchTypes'
import { SearchTab, SearchTabsHeader } from '@react/SearchResults/subcomponents'
import { ReactElement, useEffect, useState } from 'react'

type SearchProps = {
  model: string
}

export function SearchResults({ model }: SearchProps): ReactElement | null {
  const [selectedIndex, setSelectedIndex] = useState(0)
  let parsedModel
  try {
    parsedModel = JSON.parse(model)
  } catch (e) {
    return null
  }

  const { tabs, i18n } = parsedModel
  if (!tabs) {
    return null
  }
  const { resultsFound, suggestion, noResults, topResult, loadMore } = i18n
  const { initTabs, tabsData, loadMoreClick, isLoadedResults,searchParam, setSearchParam } = useSearchResults(resultsFound)
  useEffect(() => {
    const searchQuery = new URLSearchParams(searchParam).get('q')
    if (searchQuery) {
      initTabs(tabs)
    }
  }, [searchParam, setSearchParam])
  useEffect(() => {
    setSearchParam(window.location.search)
    initTabs(tabs)
  }, [])

  const tabsArray = []
  if (tabsData) {
    tabs.forEach(tab => {
      if (tabsData[tab.tabId]) {
        tabsArray.push(tabsData[tab.tabId])
      }
    })
  }

  const selectTab = (i, event) => {
    event?.preventDefault()
    if (i && selectedIndex !== i) {
      setSelectedIndex(i)
    } else {
      setSelectedIndex(0)
    }
  }

  const keyboardHandler = event => {
    if (event.key === 'ArrowRight' && selectedIndex < tabsArray.length - 1) {
      const foundNextIndex = tabsArray.findIndex((tab, index) => {
        return selectedIndex < index && tab.isVisible
      })
      if (foundNextIndex === -1) return
      setSelectedIndex(foundNextIndex)
    }
    if (event.key === 'ArrowLeft' && selectedIndex > 0) {
      const foundPrevTab = [...tabsArray].reverse().find((tab: TabType) => {
        const tabIndex = tab.tabId.split('-').pop()
        return Number(tabIndex) < selectedIndex && tab.isVisible
      })
      if (!foundPrevTab) {
        return
      }
      setSelectedIndex(Number(foundPrevTab.tabId.split('-').pop()))
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', keyboardHandler)
    return () => document.removeEventListener('keydown', keyboardHandler)
  }, [selectedIndex])
  return (
    <div className="saas-search-results-cmp" data-dm="searchresult-tabs.component" data-testid="search-results">
      {!isLoadedResults ? (
        <span className="saas-search-result-tab__loading-spinner" dangerouslySetInnerHTML={{ __html: loadingSpinnerSvg }} />
      ) : (
        <>
          <SearchTabsHeader tabsArray={tabsArray} selectedIndex={selectedIndex} selectTab={selectTab} />
          {tabsArray.map((tab: TabType, index) => (
            <SearchTab
              key={index}
              tab={tab}
              noResultsLabel={noResults}
              suggestionLabel={suggestion}
              topResultsLabel={topResult}
              loadMoreLabel={loadMore}
              isActive={index === selectedIndex}
              onLoadMore={loadMoreClick}
            />
          ))}
        </>
      )}
    </div>
  )
}
